import { z } from 'zod/v4';

export type MessageId = string;

export const zodMessage = z.object({
  id: z.string(),
  createdAt: z.number(),
  role: z.enum(['system', 'user', 'assistant']),
  content: z.string(),
});

export type Message = z.infer<typeof zodMessage>;

export const zodQuickResponse = z.object({
  emoji: z.string(),
  content: z.string(),
});

export type QuickResponse = z.infer<typeof zodQuickResponse>;

export const zodConversation = z.object({
  messages: z.array(zodMessage),
});

export type Conversation = z.infer<typeof zodConversation>;
